import styled, { withTheme } from 'styled-components';
import LogoSVG from '../../assets/images/logo.svg';

const LogoIcon = styled.span`
  background: url(\"${LogoSVG}\") no-repeat right center;
  background-size: 112px 26px;
  display: block;
  height: 26px;
  position: relative;
  width: 70%;
  margin: 20px 0;
  cursor: pointer;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 97%;
  }
`;

export default withTheme(LogoIcon);
